
import { Component } from '@angular/core';
import { QuoteCoverageCardSkeletonComponent } from '../quote-coverage-card-skeleton/quote-coverage-card-skeleton.component';

@Component({
	selector: 'app-quotes-detail-skeleton',
	imports: [QuoteCoverageCardSkeletonComponent],
	templateUrl: './quotes-detail-skeleton.component.html',
	styleUrl: './quotes-detail-skeleton.component.scss',
})
export class QuotesDetailSkeletonComponent {}
